"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmountFormatWrapper = void 0;
const react_1 = __importDefault(require("react"));
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const AmountFormatWrapper = (_a) => {
    var { active: _ } = _a, htmlProps = __rest(_a, ["active"]);
    return (react_1.default.createElement("span", Object.assign({}, htmlProps), htmlProps.children));
};
exports.AmountFormatWrapper = AmountFormatWrapper;
//# sourceMappingURL=amount-format-wrapper.js.map